(() => {
  const menu = document.querySelector('[data-rr-menu]');
  const nav = document.getElementById('rr-nav');
  if (menu && nav) {
    menu.addEventListener('click', () => {
      const open = menu.getAttribute('aria-expanded') !== 'true';
      menu.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-open', open);
    });
    nav.addEventListener('click', e => {
      if (e.target.closest('a')) {
        nav.classList.remove('is-open');
        menu.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && menu.getAttribute('aria-expanded') === 'true') {
        nav.classList.remove('is-open');
        menu.setAttribute('aria-expanded', 'false');
        menu.focus();
      }
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 1320 && menu.getAttribute('aria-expanded') === 'true') {
        nav.classList.remove('is-open');
        menu.setAttribute('aria-expanded', 'false');
      }
    });
  }
  const mowerToggle = document.querySelector('[data-rr-mower-toggle]');
  const mowerGroup = mowerToggle && mowerToggle.closest('.rr-nav-group');
  if (mowerToggle && mowerGroup) {
    mowerToggle.addEventListener('click', () => {
      const open = mowerToggle.getAttribute('aria-expanded') !== 'true';
      mowerToggle.setAttribute('aria-expanded', String(open));
      mowerGroup.classList.toggle('is-open', open);
    });
    document.addEventListener('click', e => {
      if (!mowerGroup.contains(e.target)) {
        mowerGroup.classList.remove('is-open');
        mowerToggle.setAttribute('aria-expanded', 'false');
      }
    });
    mowerGroup.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        mowerGroup.classList.remove('is-open');
        mowerToggle.setAttribute('aria-expanded', 'false');
        mowerToggle.focus();
      }
    });
  }
  const hero = document.querySelector('[data-rr-hero-video]');
  const toggle = document.querySelector('[data-rr-hero-toggle]');
  const freeze = window.matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData;
  let manuallyPaused = Boolean(freeze);
  if (hero && toggle) {
    toggle.hidden = false;
    const label = () => {
      const text = hero.paused ? 'Play video' : 'Pause video';
      toggle.textContent = text;
      toggle.setAttribute('aria-label', text + ' background');
    };
    hero.addEventListener('playing', () => {
      if (hero.requestVideoFrameCallback) hero.requestVideoFrameCallback(() => hero.classList.add('rr-video-ready'));
      else hero.classList.add('rr-video-ready');
      label();
    });
    hero.addEventListener('pause', label);
    hero.addEventListener('error', () => { hero.classList.remove('rr-video-ready'); label(); });
    toggle.addEventListener('click', () => {
      manuallyPaused = !hero.paused;
      if (manuallyPaused) hero.pause();
      else hero.play().catch(label);
    });
    label();
  }
  const films = Array.from(document.querySelectorAll('video[autoplay], video[data-rr-autoplay], video[data-rr-hero-video]'));
  films.forEach(film => { film.muted = true; film.defaultMuted = true; });
  if (!freeze) {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting && !(entry.target === hero && manuallyPaused)) entry.target.play().catch(() => {});
        else entry.target.pause();
      }), {threshold: .08});
      films.forEach(film => observer.observe(film));
    } else films.forEach(film => film.play().catch(() => {}));
  } else films.forEach(film => film.pause());
  document.querySelectorAll('[data-rr-variant-select]').forEach(select => {
    const wrapper = select.closest('.rr-product-buy, .rr-one-plus-buy-panel');
    const price = wrapper && wrapper.querySelector('[data-rr-product-price]');
    const button = wrapper && wrapper.querySelector('[data-rr-add]');
    const update = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      if (price) price.textContent = option.dataset.price;
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.innerHTML = available ? 'Add to cart <span aria-hidden="true">→</span>' : 'Unavailable';
      }
    };
    select.addEventListener('change', update);
    update();
  });
  const story = document.querySelector('[data-rr-story]');
  if (!story) return;
  const steps = Array.from(story.querySelectorAll('[data-rr-step]'));
  const frames = Array.from(story.querySelectorAll('[data-rr-frame]'));
  const counter = story.querySelector('[data-rr-counter]');
  if (!steps.length || !frames.length) return;
  let current = -1;
  const activate = index => {
    if (index === current || index < 0) return;
    current = index;
    frames.forEach((frame, i) => frame.classList.toggle('is-active', i === index));
    steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
    if (counter) counter.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(steps.length).padStart(2, '0');
  };
  activate(0);
  if (window.matchMedia('(min-width: 761px) and (prefers-reduced-motion: no-preference)').matches) {
    let pending = false;
    const update = () => {
      pending = false;
      const center = window.innerHeight * .52;
      let bestIndex = 0, bestDistance = Infinity;
      steps.forEach((step, i) => {
        const box = step.getBoundingClientRect();
        const distance = Math.abs((box.top + box.bottom) / 2 - center);
        if (distance < bestDistance) { bestDistance = distance; bestIndex = i; }
      });
      activate(bestIndex);
    };
    window.addEventListener('scroll', () => {
      if (!pending) { pending = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
})();

